export interface SnackVariableInterface {
  message?: string;
  type?: 'ERROR' | 'SUCCESS' | 'INFO';
  isOpen: boolean;
}

export const displaySnackBar = (client: any, data: SnackVariableInterface) => {
  client.writeData({
    data: {
      snackBar: { ...data, __typename: 'SnackBar' },
    },
  });
};
